/* eslint-disable react-hooks/rules-of-hooks */
import { useSearchParams } from "react-router-dom";
import { PATHS } from "@config";

const IS_REGISTER_PROCESS_QUERY_KEY = "is_register_process";
export const IS_REGISTER_PROCESS_QUERY_STRING = `?${IS_REGISTER_PROCESS_QUERY_KEY}=true`;

export const setNextUrlInRegisterProcess = (condition, pathIfTrue, pathIfFalse) => {
  const nextUrl = condition ? `${pathIfTrue}${IS_REGISTER_PROCESS_QUERY_STRING}` : pathIfFalse;
  return nextUrl;
};

export const checkRegisterProcess = () => {
  const [searchParams] = useSearchParams();
  const isRegisterProcess = searchParams.get(IS_REGISTER_PROCESS_QUERY_KEY);
  return { isRegisterProcess: Boolean(isRegisterProcess) };
};

export const getInterviewUrl = (isForeigner) => {
  return isForeigner ? `${PATHS.REGIST_FOREIGNER}` : `${PATHS.REGIST_3}`;
};

export const getForeignerRegisterUrl = (isConfirmDate) => {
  return isConfirmDate ? `${PATHS.OFFICIAL_REGIST_FOREIGNER}` : `${PATHS.REGIST_FOREIGNER}`;
};

// eslint-disable-next-line default-param-last
export const getUrlOfRegisterProcess = (isRegisterProcess, dataStaff = {}, currentPath) => {
  const {
    is_foreigner: isForeigner,
    casnavi_id: casnaviId,
    confirm_date: confirmDate,
    movie_check_date: movieCheckDate,
    image_upload_date: imageUploadDate,
    residence_card_deadline: residenceCardDeadline,
  } = dataStaff;
  let url = "";
  if (isRegisterProcess && !casnaviId) {
    if (!confirmDate) {
      const interviewUrl = getInterviewUrl(isForeigner);
      url = `${interviewUrl}${IS_REGISTER_PROCESS_QUERY_STRING}`;
    } else if (isForeigner) {
      if (
        (currentPath && currentPath.includes(PATHS.REGIST_1)) ||
        (!movieCheckDate && !imageUploadDate && !residenceCardDeadline)
      ) {
        url = `${PATHS.OFFICIAL_REGIST_FOREIGNER}${IS_REGISTER_PROCESS_QUERY_STRING}`;
      }
    } else if (currentPath && currentPath.includes(PATHS.OFFICIAL_REGIST_FOREIGNER)) {
      url = `${PATHS.REGIST_1}${IS_REGISTER_PROCESS_QUERY_STRING}`;
    }
  }
  return url;
};
